import { render, staticRenderFns } from "./SizeGroupForm.vue?vue&type=template&id=231afef3&"
import script from "./SizeGroupForm.vue?vue&type=script&lang=js&"
export * from "./SizeGroupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports